import ViewBase from '../../view-base.view';

export default function ResultDialog(vnode) {
  ViewBase.call(this);

  let list = [];

  const handleCancel = (e) => {
    vnode.attrs.onClose?.(e);
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.resultList) {
        list = vnode.attrs.resultList
      }
    },
    view: (vnode) => {
      return [
        m('.card',
          m('.card-body',
            m(".table-responsive",
              m("table.table", [
                m("thead",
                  m("tr.align-middle", [
                    m("th", { "scope": "col" }, this.getText("LT00000049", "User ID")),
                    m("th", { "scope": "col" }, this.getText("LT00000050", "User Name")),
                    m("th", { "scope": "col" }, this.getText("LT00000015", "Status")),
                    m("th", { "scope": "col" }, this.getText("LT00000152", "Remarks"))
                  ])
                ),
                m("tbody",
                  list.length == 0 &&
                  m("tr", { "class": "align-middle" },
                    m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                  ),
                  list.map(gc => [
                    m("tr", [
                      m("td", gc.userId),
                      m("td", gc.userName),
                      m("td", gc.transStatus),
                      m("td", gc.message)
                    ])
                  ]),
                )
              ])
            ),
          )
        ),
        m('.col-md-12.gap-2.mt-4.d-flex.justify-content-center',
          m(
            "button.btn.btn-white[type='button']", { onclick: handleCancel },
            this.getText("LT00000021", "Close")
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}